module.exports = __webpack_public_path__ + "img/inventory-bag.e56993cc.svg";